import { render, staticRenderFns } from "./ActiveCampaigns.vue?vue&type=template&id=8df3e22e&"
import script from "./ActiveCampaigns.vue?vue&type=script&lang=js&"
export * from "./ActiveCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports